export enum LeadType {
  ArticleLead = 'article_lead',
  BriefingLead = 'briefing_lead',
  Gift = 'gift',
  MarketingModal = 'marketing_modal',
  Organic = 'organic',
  Promo = 'promo',
  Referred = 'referred',
  ShareArticle = 'share_article',
  TIApp = 'ti_app',
}

export enum FormLocation {
  Footer = 'footer',
  GlobalPopupEmailCapture = 'global_popup_email_capture',
  LeadCaptureModal = 'lead_capture_modal',
  LeadStickyBanner = 'lead_sticky_banner',
  LegacyProject = 'legacy_project',
  MarketingModal = 'marketing_modal',
  NewsletterLanding = 'newsletter_landing',
  ProLeadCaptureForm = 'pro_lead_capture_form',
  ProPaywall = 'pro_paywall',
  ReadThisArticle = 'read_this_article',
  Paywall = 'paywall',
  PaywallStickyBanner = 'paywall_sticky_banner',
  RightRail = 'right_rail',
  ShareWithOauth = 'share_with_oauth',
  SpecialOfferBanner = 'special_offer_banner',
  Subscribe = 'subscribe',
  SubscribeModal = 'subscribe_modal',
  WeekendSubscribeForm = 'weekend_subscribe_form',
}
